import { toast, ToastOptions } from "react-toastify";

const defaults: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
};

export function toastSuccess(message: string, options?: ToastOptions) {
  return toast.success(message, { ...defaults, ...options });
}

export function toastError(message: string, options?: ToastOptions) {
  return toast.error(message, { ...defaults, ...options });
}

export function toastInfo(message: string, options?: ToastOptions) {
  return toast.info(message, { ...defaults, ...options });
}
